import { validateObject, validateField, isRequired } from "common/validation";
import { isBlank } from "common/general";
import { curry, mergeRight } from "ramda";

const constraints = fieldOptions => {
  let constraints = {
    firstName: {
      presence: {
        allowEmpty: false,
        message: "^validation_fname_required",
      },
    },
    lastName: {
      presence: {
        allowEmpty: false,
        message: "^validation_lname_required",
      },
    },
    email: {
      presence: {
        allowEmpty: false,
        message: "^validation_email_required",
      },
      email: {
        message: "^validation_email_invalid",
      },
    },
    role: {
      presence: {
        allowEmpty: false,
        message: "^validation_role_required",
      },
    },
  };

  if (isRequired("local_library", fieldOptions)) {
    constraints = mergeRight(constraints, {
      localLibrary: (
        value,
        attributes,
        attributeName,
        options,
        constraints
      ) => {
        return isBlank(attributes.localLibrary) &&
          isBlank(attributes.localLibraryOther)
          ? {
              presence: {
                allowEmpty: false,
                message: "^validation_library_required",
              },
            }
          : null;
      },
      localLibraryOther: (
        value,
        attributes,
        attributeName,
        options,
        constraints
      ) =>
        isBlank(attributes.localLibrary) &&
        isBlank(attributes.localLibraryOther)
          ? {
              presence: {
                allowEmpty: false,
                message: "^validation_other_library_required",
              },
            }
          : null,
    });
  }

  if (isRequired("freeform_personal_data", fieldOptions)) {
    constraints = mergeRight(constraints, {
      freeformPersonalData: {
        presence: {
          allowEmpty: false,
          message: "^validation_freeform_personal_data_required",
        },
      },
    });
  }

  if (isRequired("freeform_personal_data_2", fieldOptions)) {
    constraints = mergeRight(constraints, {
      freeformPersonalData2: {
        presence: {
          allowEmpty: false,
          message: "^validation_freeform_personal_data_2_required",
        },
      },
    });
  }

  if (isRequired("middle_name", fieldOptions)) {
    constraints = mergeRight(constraints, {
      middleName: {
        presence: {
          allowEmpty: false,
          message: "^validation_mname_required",
        },
      },
    });
  }

  if (isRequired("prefix", fieldOptions)) {
    constraints = mergeRight(constraints, {
      prefix: {
        presence: {
          allowEmpty: false,
          message: "^validation_prefix_required",
        },
      },
    });
  }

  if (isRequired("suffix", fieldOptions)) {
    constraints = mergeRight(constraints, {
      suffix: {
        presence: {
          allowEmpty: false,
          message: "^validation_suffix_required",
        },
      },
    });
  }

  if (isRequired("country", fieldOptions)) {
    constraints = mergeRight(constraints, {
      country: {
        presence: {
          allowEmpty: false,
          message: "^validation_country_required",
        },
      },
    });
  }

  if (isRequired("region", fieldOptions)) {
    constraints = mergeRight(constraints, {
      region: {
        presence: {
          allowEmpty: false,
          message: "^validation_region_required",
        },
      },
    });
  }

  if (isRequired("locality", fieldOptions)) {
    constraints = mergeRight(constraints, {
      locality: {
        presence: {
          allowEmpty: false,
          message: "^validation_city_required",
        },
      },
    });
  }

  let twitterConstraint = {
    format: {
      pattern: /^(@[A-Za-z0-9_]+)?$/,
      message: "^validation_twitter_invalid",
    },
  };
  if (isRequired("twitter_handle", fieldOptions)) {
    twitterConstraint = mergeRight(twitterConstraint, {
      presence: {
        allowEmpty: false,
        message: "^validation_twitter_required",
      },
    });
  }
  constraints = mergeRight(constraints, {
    twitterHandle: twitterConstraint,
  });

  let websiteConstraint = {
    format: {
      pattern: /^[^ "]*$/,
      message: "^validation_website_invalid",
    },
  };
  if (isRequired("website", fieldOptions)) {
    websiteConstraint = mergeRight(websiteConstraint, {
      presence: {
        allowEmpty: false,
        message: "^validation_website_required",
      },
    });
  }
  constraints = mergeRight(constraints, {
    website: websiteConstraint,
  });

  return constraints;
};

export const validateBasicDetailsField = (
  field,
  value,
  fieldOptions,
  errors = {}
) => validateField(constraints(fieldOptions), field, value, errors);

export const validateBasicDetails = curry((fieldOptions, fields) =>
  validateObject(constraints(fieldOptions), fields)
);
